module.exports = __webpack_public_path__ + "assets/img/securitiesSolutions-op.e4b9a298.png";